import React, { useState, useEffect } from 'react';
// import D3js from 'components/doc-components/charts-example/dsp';
import IconButton from 'components/common/IconButton';

// import DSAProgress from 'components/dashboards/project-management/DSAProgress';
import DSASeriesBarChart from 'components/doc-components/charts-example/echarts/bar-charts/DSASeriesBarChart';
// import HorizontalBarGraph from 'components/doc-components/charts-example/echarts/bar-charts/HorizontalBarGraph';
// From DSAQuestions
// import PropTypes from 'prop-types';
import { Card, ProgressBar } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import Form from 'react-bootstrap/Form';

// For progress bar
import FalconCardHeader from 'components/common/FalconCardHeader';

// import ReactPaginate from 'react-paginate';
// import { index } from 'd3';
// import DSAPages from 'components/dashboards/e-commerce/recent-purchases/DSAPages';

// import { useAppContext } from 'providers/AppProvider';
// import ReactEchart from 'components/common/ReactEchart';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
// import { tooltipFormatter } from 'helpers/echart-utils';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';

import generatePDF, { Resolution, Margin, usePDF } from 'react-to-pdf';
import emailjs, { sendForm } from '@emailjs/browser';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from "axios";
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
// import { Platform } from 'react-native';
// import dspPdfFile from "components/doc-components/charts-example/echarts/bar-charts/SelfPowermentReport-72.pdf";
// import Lottie from 'lottie-react'
// import celebration from './lottie/celebration.json';
// <Lottie animationData={celebration} loop={true} />
import { v4 as uuidv4 } from 'uuid';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

// console.log(window.location.search);

const dspversion = "v2.05.011";
const params = new URLSearchParams(window.location.search);
const contact_email = params.get("email");
const contact_name = params.get("name");
const appname = params.get("app");
const isDev = false;

const  EJS_SERVICE_ID = "service_nhxx7zq";
const EJS_TEMPLATE_ID = "template_06kn689";
// const EJS_TEMPLATE_ID = "template_kmvyngi"; // release
const EJS_PUBLIC_KEY = "1JyWi_f1dVaT-6WkD";




// const Component = () => {
  

  // const handleGeneratePdf = async () => {
    
  //   // Handle the blob here, e.g., download or preview
  // };

 
      // <button onClick={handleGeneratePdf}>Generate PDF</button>
 


const DSAssessment = (prop) => {
  // const { toPDF, targetRef } = usePDF({
  //   method: "save",
  //   filename: "SelfPowermentReport5.pdf",
  //   page: { margin: Margin.MEDIUM },
  // });
  // const [progress, setProgress] = useState("");
  const [answer, setAnswer] = useState("");
  // const [group, setGroup] = useState("");
  // const [core, setCore] = useState("");

  
  const [investTotal, setInvestTotal] = useState(0);
  const [quietTotal, setQuietTotal] = useState(0);
  const [trustTotal, setTrustTotal] = useState(0);
  const [honorTotal, setHonorTotal] = useState(0);
  const [harnessTotal, setHarnessTotal] = useState(0);
  const [ownTotal, setOwnTotal] = useState(0);
  const [connectTotal, setConnectTotal] = useState(0);
  const [beTotal, setBeTotal] = useState(0);
  
  // const [showReport, setShowReport] = useState(isDev? true : false);
  const [showReport, setShowReport] = useState(isDev? true : false);
  const [platform, setPlatform] = useState("");
  const [reportdate, setReportDate] = useState(new Date());

  
  const targetRef = React.useRef();
  var deb = isDev ? 'kevin.mcisaac.smith@gmail.com' : 'debmsmallwood@gmail.com'; // "debmsmallwood@gmail.com";
  var scg = "info@scgrmm.com";
  var reply = "no-reply@scgrmm.com";
  var subject = "SELFPowerment Survey Report";
  var message = "Hello Deb!";
  var bcc = "info@scgrmm.com";

  // useEffect(() => {
  //   if(showReport){
  //     setShowReport(true);
  //     HandleGeneratePdf();
  //     };
  //   }, [showReport]);
  
  
  // Prepare event data
   const eventData = {
    name: "Shenkson Apps - DSP",
    message: 'Assessment progress notification.',
  };

  const HandleGeneratePdf = async (formData) => {

   
    // setShowReport(true);

    try {
        const content = targetRef.current;
        const canvas = await html2canvas(content);
        const imgData = canvas.toDataURL('image/png');
  
        const pdf = new jsPDF('p', 'in', 'a4', true);
        const pdfWidth = 9; //pdf.internal.pageSize.getWidth();
        const pdfHeight = 8; //pdf.internal.pageSize.getHeight();
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

        console.log(pdfWidth, pdfHeight);
  
        const pdfBlob = pdf.output('blob');

        // Check file size
        if (pdfBlob.size > 4 * 1024 * 1024) { // 4MB limit
          console.log("PDF file is too large to send via email. Please reduce content.");
          return;
        }
  
        // Convert blob to base64
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = function () {
        const base64data = reader.result;

        // Prepare email data
        const emailData = {
          to: scg,
          from: reply,
          replyemail: reply,
          bcc: bcc,
          subject: subject,
          name: "Shenkson Apps - DSP",
          message: 'Please find your PDF report attached.',
          content: base64data,
        };

       

        // Prepare micro email data
        const dformData = new FormData();
        dformData.append('to', deb);
        dformData.append('from', reply);
        dformData.append('subject', subject);
        dformData.append('html', message);
        dformData.append('name', "Shenkson Apps - DSP");
        dformData.append('bcc', bcc);
        dformData.append('attachments', base64data);
  
       

        // Send email using EmailJS
        emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, formData, EJS_PUBLIC_KEY)
          .then((result) => {
            console.log('Email sent successfully:', result.text);
          }, (error) => {
            console.error('Error sending email:', error.text);
          });

          // // Send email using Micro3030
          // const response = fetch(micro3030e, {
          //     method: 'POST',
          //     body: dformData,
          //   });
          //   const data = response;
          //   console.log('File uploaded successfully:', data);

      };
      } catch (error) {
      console.error('Error generating PDF:', error);
    }

    
    
  };

  const eventNotification = async (formData) => {

    try {
        // Send email using EmailJS
        emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, formData, EJS_PUBLIC_KEY)
          .then((result) => {
            // console.log('Notification sent successfully:', result.text);
          }, (error) => {
            // console.error('Error sending notification:', error.text);
          });

    //       // // Send email using Micro3030
    //       // const response = fetch(micro3030e, {
    //       //     method: 'POST',
    //       //     body: dformData,
    //       //   });
    //       //   const data = response;
    //       //   console.log('File uploaded successfully:', data);
          

      } catch (error) {
      console.error('notification error:', error);
    }


    // try {
    //   const resp = await axios.post("http://heliconia.scgrmm.com:3030/api/send", {
    //     from: "info@scgrmm.com",  
    //     to: "kevins@shenkson.com",
    //     subject: "SELFPowerment Report",
    //     html: message
    //   });
    //   console.log("Email sent!");
    // } catch(err) {
    //   console.log(err);
    // }
  // const dspdata = {"os": "macos", "platform": "MobileTest", "type": "74%", "screen_size": "797", "ip_address": "10.0.0.1"}
    
    try {

      const getOS = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
      
        if (macosPlatforms.indexOf(platform) !== -1) {
          return 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
          return 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          return 'Windows';
        } else if (/Android/.test(userAgent)) {
          return 'Android';
        } else if (/Linux/.test(platform)) {
          return 'Linux';
        }
      
        return 'Unknown OS';
      };

      const getBrowser = () => {
        const userAgent = navigator.userAgent;
        let browserName;
      
        if (userAgent.match(/chrome|chromium|crios/i)) {
          browserName = "Chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
          browserName = "Firefox";
        } else if (userAgent.match(/safari/i)) {
          browserName = "Safari";
        } else if (userAgent.match(/opr\//i)) {
          browserName = "Opera";
        } else if (userAgent.match(/edg/i)) {
          browserName = "Edge";
        } else {
          browserName = "Unknown browser";
        }
      
        return browserName;
      };

      const getScreenSize = () => {
        return {
          width: window.screen.width,
          height: window.screen.height
        };
      };

      let os = getOS();
      let browser = getBrowser();
      let screensize =  getScreenSize();

      // console.log(screensize.height);
  
  
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile1 = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
      const isTablet1 = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

      let device = 'Desktop';
      if (isMobile1) {
        device = 'Mobile';
      } else if (isTablet1) {
        device = 'Tablet';
      }

      const refer = '. Referrer: ' + document.referrer;
      const response_ip = await axios.get("/mit/tobler/getip")
      // console.log(response_ip.data.ip);
      
      let date = Date.now();

      const response = await axios.post("/mit/tobler/systemlog", {
        sessionid: sessionStorage.getItem('dspdata'),
        os: os, 
        platform: device, 
        screen_size: screensize.width + 'x' + screensize.height, 
        ip: response_ip.data.ip,
        date_entered: date,
        date: date,
        deleted: 0,
        description: formData.subject + refer,
        system_action: 'Survey progress',
        log_type: 'INFO',
        name: 'DSP-Self_Assessment',       
        country: 'clong',
        abbr: 'cshort',
        agent: browser
        },
        {
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}`
          }
        });
      // console.log(response);
      // if (!sessionStorage.getItem('dspdata'))
      //   sessionStorage.setItem('dspdata', response.data.id);
    } catch(response) {
      // console.log(err);
      console.log(response);
    }
    // console.log(response);
    
  };


  useEffect(() => {
    // console.log('Referrer:', document.referrer);
    sessionStorage.setItem('dspdata', uuidv4());
  }, []);

  return (
    <>
    
    <QuizPagination 
      answer={answer}
      eventNotification={eventNotification}
      setShowReport={setShowReport}
      showReport={showReport}
      setInvest={setInvestTotal} 
      setQuiet={setQuietTotal}
      setTrust={setTrustTotal}
      setHonor={setHonorTotal}
      setHarness={setHarnessTotal}
      setOwn={setOwnTotal}
      setConnect={setConnectTotal}
      setBe={setBeTotal}
      setReportDate={setReportDate}
      questions={questions}
    />

    {/* <HorizontalBarGraph /> */}
    
    {showReport &&
    // <Lottie animationData={infiniteLoop} loop={true}  style={{height: '120px', width: '120px'}} />
    <div ref={targetRef}>
    <DSASeriesBarChart 
      invest={investTotal} 
      quiet={quietTotal} 
      trust={trustTotal} 
      honor={honorTotal}
      harness={harnessTotal} 
      own={ownTotal} 
      connect={connectTotal} 
      be={beTotal} 
      dspversion={dspversion}
      reportdate={reportdate}
      contact_email={contact_email}
      contact_name={contact_name}
      appname={appname}
        />
    </div>
    }
    
    </>
   
  );
};

  // Question prototype - question, category, state, answers
  // Category aware, align, ack, awaken
  // State harness, invest, quiet, trust, honor, own, connect, be
  // Report Logic: 8 group totals by record value 'state'
  // Progress Logic: currentPage / totalPages * 100
  // const questionsOld = [
  //   {id: 1, question: 'I am aware of my unique strengths, passions, and talents.', category: 'ack', state: 'harness'},
  //   {id: 2, question: 'I prioritize self-care as part of my daily routine.', category: 'ack', state: 'invest'},
  //   {id: 3, question: 'I listen to and trust my inner voice when making decisions.', category: 'awaken', state: 'trust'},
  //   {id: 4, question: 'I take responsibility for my actions and decisions, regardless of the outcome.', category: 'accept', state: 'own'},
  //   {id: 5, question: 'I have clarity in my purpose, even during challenging times.', category: 'awaken', state: 'trust'},
  //   {id: 6, question: 'I have learned to let go of things I cannot control and fully embrace the present moment.', category: 'accept', state: 'honor'},
  //   {id: 7, question: 'I build meaningful and uplifting connections in my personal and professional life.', category: 'align', state: 'connect'},
  //   {id: 8, question: 'I show up as my authentic self in the workplace.', category: 'align', state: 'be'},
  //   {id: 9, question: 'I cultivate a personal brand that reflects who I truly am.', category: 'align', state: 'be'},
  //   {id: 10, question: 'I focus on the moment without drifting into regrets about the past or worries about the future. ', category: 'accept', state: 'honor'},
  //   {id: 11, question: 'I feel at peace.', category: 'awaken', state: 'quiet'},
  //   {id: 12, question: 'I have clarity about my limiting beliefs and past experiences that may restrict my growth and potential and can manage them.', category: 'ack', state: 'harness'},
  //   {id: 13, question: 'I eat healthy and have a balanced diet.', category: 'ack', state: 'invest'},
  //   {id: 14, question: 'I am aware of my challenges, weaknesses, and areas where I struggle or don’t excel. ', category: 'ack', state: 'harness'},
  //   {id: 15, question: 'I engage in various activities that cultivate mindfulness and inner stillness/calmness. ', category: 'awaken', state: 'quiet'},
  //   {id: 16, question: 'I practice being present in the moment.', category: 'accept', state: 'honor'},
  //   {id: 17, question: 'I am intentional with my words and actions in professional communication.', category: 'align', state: 'be'},
  //   {id: 18, question: 'I have a network of allies, co-workers, sponsors, mentors I can always count on for support and guidance.', category: 'align', state: 'connect'},
  //   {id: 19, question: 'I embrace the reality that my career and life choices are ultimately mine to make.', category: 'accept', state: 'own'},
  //   {id: 20, question: 'I am not afraid to make decisions that could impact my career or financial situation.', category: 'accept', state: 'own'},
  //   {id: 21, question: 'I feel a sense of power from my wisdom.', category: 'awaken', state: 'trust'},
  //   {id: 22, question: 'I eﬀectively manage with ease both my personal and professional life.', category: 'accept', state: 'own'},
  //   {id: 23, question: 'I sense and feel the diﬀerences of “gut feelings” and factual logic.', category: 'awaken', state: 'trust'},
  //   {id: 24, question: 'I use my power of my breath to help bring calmness and ground me.', category: 'awaken', state: 'quiet'},
  //   {id: 25, question: 'I consciously can redirect my negative thoughts and feelings when my mind starts to spin.', category: 'awaken', state: 'quiet'},
  //   {id: 26, question: 'I recognize when I need a break and take time to nurture myself.', category: 'ack', state: 'invest'},
  //   {id: 27, question: 'I feel confident and ready to tackle any opportunity or challenge that comes my way.', category: 'ack', state: 'harness'},
  //   {id: 28, question: 'I believe in my full human capabilities, powers and my potential.', category: 'ack', state: 'harness'},
  //   {id: 28, question: 'I believe in investing in my mental, physical, and emotional needs.', category: 'ack', state: 'invest'},
  //   {id: 30, question: 'I intentionally cultivate a network of mentors and sponsors within my organization.', category: 'align', state: 'connect'},
  //   {id: 31, question: 'I feel comfortable asking for help or guidance from my network.', category: 'align', state: 'connect'},
  //   {id: 32, question: 'I align my professional actions with my authentic self.', category: 'align', state: 'be'},
  //   {id: 33, question: "I prioritize making choices for myself rather than prioritizing based on others' expectations or other beliefs or opinions.", category: 'accept', state: 'own'},
  //   {id: 34, question: 'I have a clear sense of my life’s purpose.', category: 'awaken', state: 'trust'},
  //   {id: 35, question: 'I set boundaries to protect my time and energy from being overextended.', category: 'ack', state: 'invest'},
  //   {id: 36, question: 'I invest in professional development to enrich my skills set in my career.', category: 'ack', state: 'harness'},
  //   {id: 37, question: 'I recognize when my mind becomes cluttered with negative self-talk or mental noise.', category: 'awaken', state: 'quiet'},
  //   {id: 38, question: 'I take time to evaluate how my daily life actions align with my life’s purpose.', category: 'awaken', state: 'trust'},
  //   {id: 39, question: 'I am accountable for my decisions and actions.', category: 'accept', state: 'own'},
  //   {id: 40, question: 'I believe in the power of honoring the present moment.', category: 'accept', state: 'honor'},
  //   {id: 41, question: 'I intentionally build relationships with peers, partners, mentors and sponsors outside of my organization.', category: 'align', state: 'connect'},
  //   {id: 42, question: 'I take mindful breaths to ground myself.', category: 'awaken', state: 'quiet'},
  //   {id: 43, question: 'I accept both the pleasant and challenging aspects of life without resistance.', category: 'accept', state: 'honor'},
  //   {id: 44, question: 'I prioritize getting enough sleep and maintaining a consistent sleep schedule.', category: 'ack', state: 'invest'},
  //   {id: 45, question: 'I make an eﬀort to attend events or activities that expand my network. ', category: 'align', state: 'connect'},
  //   {id: 46, question: 'I experience peace and gratitude by accepting what is.', category: 'accept', state: 'honor'},
  //   {id: 47, question: 'I strive to use the right tone and voice to create meaningful and positive influence.', category: 'align', state: 'be'},
  //   {id: 48, question: 'I am aligned in my current career with my life purpose.', category: 'align', state: 'be'},
  //   {id: 49, question: '', category: '', state: ''}
  // ];

  // const questionsV1_06_01 = [
  //   {id: 1, question: 'I am aware of my unique strengths, passions, and talents.', category: 'ack', state: 'harness'},
  //   {id: 2, question: 'I prioritize self-care as part of my daily routine.', category: 'ack', state: 'invest'},
  //   {id: 3, question: 'I listen to and trust my inner voice when making decisions.', category: 'awaken', state: 'trust'},
  //   {id: 4, question: 'I take responsibility for my actions and decisions, regardless of the outcome.', category: 'accept', state: 'own'},
  //   {id: 5, question: 'I have clarity about my purpose, even during challenging times.', category: 'awaken', state: 'trust'},
  //   {id: 6, question: 'I have learned to let go of things I cannot control and fully embrace the present moment.', category: 'accept', state: 'honor'},
  //   {id: 7, question: 'I build meaningful and uplifting connections in my personal and professional life.', category: 'align', state: 'connect'},
  //   {id: 8, question: 'I show up as my authentic self in the workplace.', category: 'align', state: 'be'},
  //   {id: 9, question: 'I cultivate a personal brand that reflects who I truly am.', category: 'align', state: 'be'},
  //   {id: 10, question: 'I focus on the moment without drifting into regrets about the past or worries about the future. ', category: 'accept', state: 'honor'},
  //   {id: 11, question: 'I feel at peace.', category: 'awaken', state: 'quiet'},
  //   {id: 12, question: 'I have clarity about my limiting beliefs and past experiences that may restrict my growth and potential and have learned to manage them.', category: 'ack', state: 'harness'},
  //   {id: 13, question: 'I eat healthily and have a balanced diet.', category: 'ack', state: 'invest'},
  //   {id: 14, question: "I am aware of my challenges and weaknesses, including areas where I struggle or don't excel. ", category: 'ack', state: 'harness'},
  //   {id: 15, question: 'I engage in various activities that cultivate mindfulness and inner stillness. ', category: 'awaken', state: 'quiet'},
  //   {id: 16, question: 'I practice being present in the moment.', category: 'accept', state: 'honor'},
  //   {id: 17, question: 'I am intentional with my words and actions in professional communication.', category: 'align', state: 'be'},
  //   {id: 18, question: 'I have a network of allies, co-workers, sponsors and mentors whom I can always count on for support and guidance.', category: 'align', state: 'connect'},
  //   {id: 19, question: 'I embrace the reality that my career and life choices are ultimately mine to make.', category: 'accept', state: 'own'},
  //   {id: 20, question: 'I am not afraid to make decisions that could impact my career or financial situation.', category: 'accept', state: 'own'},
  //   {id: 21, question: 'I feel a sense of power from my wisdom.', category: 'awaken', state: 'trust'},
  //   {id: 22, question: 'I eﬀectively manage both my personal and professional life with ease.', category: 'accept', state: 'own'},
  //   {id: 23, question: 'I sense the diﬀerences between “gut feelings” and factual logic.', category: 'awaken', state: 'trust'},
  //   {id: 24, question: 'I use the power of my breath to help bring calmness and to ground me.', category: 'awaken', state: 'quiet'},
  //   {id: 25, question: 'I am able to consciously redirect my negative thoughts and feelings when my mind starts to spin.', category: 'awaken', state: 'quiet'},
  //   {id: 26, question: 'I recognize when I need a break and take time to nurture myself.', category: 'ack', state: 'invest'},
  //   {id: 27, question: 'I feel confident and ready to tackle any opportunity or challenge that comes my way.', category: 'ack', state: 'harness'},
  //   {id: 28, question: 'I believe in my full human capabilities, powers and potential.', category: 'ack', state: 'harness'},
  //   {id: 29, question: 'I believe in investing in my mental, physical and emotional needs.', category: 'ack', state: 'invest'},
  //   {id: 30, question: 'I intentionally cultivate a network of mentors and sponsors within my organization.', category: 'align', state: 'connect'},
  //   {id: 31, question: 'I feel comfortable asking for help or guidance from my network.', category: 'align', state: 'connect'},
  //   {id: 32, question: 'I align my professional actions with my authentic self.', category: 'align', state: 'be'},
  //   {id: 33, question: "I prioritize making choices for myself rather than basing choices on others' expectations, beliefs or opinions.", category: 'accept', state: 'own'},
  //   {id: 34, question: 'I feel aligned with my life purpose and my current career.', category: 'awaken', state: 'trust'},
  //   {id: 35, question: 'I set boundaries to protect my time and energy from being overextended.', category: 'ack', state: 'invest'},
  //   {id: 36, question: 'I invest in professional development to enrich my skill-set in my career.', category: 'ack', state: 'harness'},
  //   {id: 37, question: 'I recognize when my mind becomes cluttered with negative self-talk or mental noise.', category: 'awaken', state: 'quiet'},
  //   {id: 38, question: 'I take time to evaluate how my daily life actions align with my life’s purpose.', category: 'awaken', state: 'trust'},
  //   {id: 39, question: 'I am accountable to myself first before others.', category: 'accept', state: 'own'},
  //   {id: 40, question: 'I believe in the power of honoring the present moment.', category: 'accept', state: 'honor'},
  //   {id: 41, question: 'I intentionally build relationships with peers, partners, mentors and sponsors outside of my organization.', category: 'align', state: 'connect'},
  //   {id: 42, question: 'I use breath work and or mediation techniques to quiet the noise in my head.', category: 'awaken', state: 'quiet'},
  //   {id: 43, question: 'I accept both the pleasant and challenging aspects of life without resistance.', category: 'accept', state: 'honor'},
  //   {id: 44, question: 'I prioritize getting enough sleep and maintaining a consistent sleep schedule.', category: 'ack', state: 'invest'},
  //   {id: 45, question: 'I make an eﬀort to attend events or activities that expand my network. ', category: 'align', state: 'connect'},
  //   {id: 46, question: 'I experience peace and gratitude by accepting what is.', category: 'accept', state: 'honor'},
  //   {id: 47, question: 'I strive to use the right tone and voice to create meaningful and positive influence.', category: 'align', state: 'be'},
  //   {id: 48, question: 'I am aligned with my life purpose in my current career.', category: 'align', state: 'be'},
  //   {id: 49, question: '', category: '', state: ''}
  // ];

  const questions = [
    {id: 1, question: 'I am aware of my unique strengths, passions, and talents and how I use them.', category: 'ack', state: 'harness'},
    {id: 2, question: 'I prioritize self-care as part of my daily routine.', category: 'ack', state: 'invest'},
    {id: 3, question: 'I listen to and trust my inner voice when making decisions.', category: 'awaken', state: 'trust'},
    {id: 4, question: 'I take responsibility for my actions and decisions, regardless of the outcome.', category: 'accept', state: 'own'},
    {id: 5, question: 'I have clarity in my purpose, even during challenging times.', category: 'awaken', state: 'trust'},
    {id: 6, question: 'I am able to let go of things I cannot control and work with what is.', category: 'accept', state: 'honor'},
    {id: 7, question: 'I build meaningful and uplifting connections in my personal and professional life.', category: 'align', state: 'connect'},
    {id: 8, question: 'I show up as my authentic self in the workplace.', category: 'align', state: 'be'},
    {id: 9, question: 'I express a professional presence or brand that reflects who I truly am.', category: 'align', state: 'be'},
    {id: 10, question: 'I focus on the moment without drifting into regrets about the past or worries about the future.', category: 'accept', state: 'honor'},
    {id: 11, question: 'I experience moments of peace, even during busy or demanding times.', category: 'awaken', state: 'quiet'},
    {id: 12, question: 'I have awareness of limiting beliefs or past experiences that may restrict my growth — and can work with them constructively.', category: 'ack', state: 'harness'},
    {id: 13, question: 'I make generally healthy choices that support my energy and well-being.', category: 'ack', state: 'invest'},
    {id: 14, question: "I am aware of my challenges and weaknesses, including areas where I struggle or don't excel. ", category: 'ack', state: 'harness'},
    {id: 15, question: 'I engage in various activities that cultivate mindfulness and inner stillness/calmness.', category: 'awaken', state: 'quiet'},
    {id: 16, question: 'I practice being present in the moment.', category: 'accept', state: 'honor'},
    {id: 17, question: 'I am intentional with my words and actions in professional communication.', category: 'align', state: 'be'},
    {id: 18, question: 'I have a network of allies, co-workers, sponsors, mentors I can always count on for support and guidance.', category: 'align', state: 'connect'},
    {id: 19, question: 'I embrace the reality that my career and life choices are ultimately mine to make.', category: 'accept', state: 'own'},
    {id: 20, question: 'I am willing to make thoughtful decisions that may impact my career or personal finances.', category: 'accept', state: 'own'},
    {id: 21, question: 'I feel a sense of power from my wisdom.', category: 'awaken', state: 'trust'},
    {id: 22, question: 'I am generally able to manage my personal and professional demands without constant strain.', category: 'accept', state: 'own'},
    {id: 23, question: 'I can distinguish between intuitive “gut” signals and factual or logical input.', category: 'awaken', state: 'trust'},
    {id: 24, question: 'I use my power of my breath to help bring calmness and ground me.', category: 'awaken', state: 'quiet'},
    {id: 25, question: 'When my mind starts to spin, I can redirect my thoughts and ground myself.', category: 'awaken', state: 'quiet'},
    {id: 26, question: 'I  recognize when I need a break and take time to nurture myself. ', category: 'ack', state: 'invest'},
    {id: 27, question: 'I generally feel confident and capable when facing new opportunities or challenges.', category: 'ack', state: 'harness'},
    {id: 28, question: 'I believe in my full human capabilities, powers and potential.', category: 'ack', state: 'harness'},
    {id: 29, question: 'I believe in investing in my mental, physical and emotional needs.', category: 'ack', state: 'invest'},
    {id: 30, question: 'I intentionally cultivate a network of mentors and sponsors within my organization.', category: 'align', state: 'connect'},
    {id: 31, question: 'I feel comfortable asking for help or guidance from my network.', category: 'align', state: 'connect'},
    {id: 32, question: 'I align my professional actions with my authentic self.', category: 'align', state: 'be'},
    {id: 33, question: "I prioritize making choices for myself rather than prioritizing based on others' expectations or other beliefs or opinions.", category: 'accept', state: 'own'},
    {id: 34, question: 'I have a general sense of my life’s purpose and what matters most to me.', category: 'awaken', state: 'trust'},
    {id: 35, question: 'I set boundaries to protect my time and energy from being overextended.', category: 'ack', state: 'invest'},
    {id: 36, question: 'I invest in professional development to enrich my skill-set in my career.', category: 'ack', state: 'harness'},
    {id: 37, question: 'I recognize when my mind becomes cluttered with negative self-talk or mental noise.', category: 'awaken', state: 'quiet'},
    {id: 38, question: 'I take time to evaluate how my daily life reflect my life’s purpose.', category: 'awaken', state: 'trust'},
    {id: 39, question: 'I am accountable for my decisions and actions. ', category: 'accept', state: 'own'},
    {id: 40, question: 'I believe in the power of honoring the present moment.', category: 'accept', state: 'honor'},
    {id: 41, question: 'I intentionally build relationships with peers, partners, mentors and sponsors outside of my organization.', category: 'align', state: 'connect'},
    {id: 42, question: 'I take mindful breaths to ground myself.', category: 'awaken', state: 'quiet'},
    {id: 43, question: 'I am able to accept both pleasant and challenging aspects of life with less resistance.', category: 'accept', state: 'honor'},
    {id: 44, question: 'I prioritize sleep and recovery as part of my overall well-being.', category: 'ack', state: 'invest'},
    {id: 45, question: 'I intentionally engage in opportunities that support meaningful connection and growth.', category: 'align', state: 'connect'},
    {id: 46, question: 'I experience peace and gratitude by accepting what is.', category: 'accept', state: 'honor'},
    {id: 47, question: 'I strive to use the right tone and voice to create meaningful and positive influence.', category: 'align', state: 'be'},
    {id: 48, question: 'I am aligned in my current career with my life purpose.', category: 'align', state: 'be'},
    {id: 49, question: '', category: '', state: ''}
  ];
 

  const weights = [
    {id: 'always', value: 15},
    {id: 'usually', value: 10},
    {id: 'sometimes', value: 5},
    {id: 'rarely', value: 2},
    {id: 'never', value: 0}
  ];

  function AssessmentChoices(props) {

    const [answer, setAnswer] = useState("");
    // const [selectedBtn, setSelectedBtn] = useState("");
    
  

    // const isRadioSelected = (value) => {
    //   console.log(selectedBtn);
    //   console.log(value);
    //   selectedBtn === value;
    // }

    const handleRadioClick = (e) => {
      // console.log(e.currentTarget.value);
      props.setSelectedBtn(e.currentTarget.value);
    }
    
    const [questionArray, setQuestionArray] = useState(questions);
    // console.log(questionArray)
    // console.log(props.questionId);
    
    
    // console.log(questionArray);
    // console.log(props.questionId);

    const onAnswerSelected = (answer) => {
      const updateItem = (itemId, newName) => {
        // Create a new array with the updated item
        setQuestionArray(questionArray.map(question =>
          question.id === itemId ? { ...question, choice: newName, updateID: itemId } : question
        ));
        props.setSelected(true);
        // setSelectedBtn("never");
        // console.log(answer);
        // setSelectedBtn();
      };
    
      updateItem(props.questionId, answer);

      // console.log(props.selectedBtn);
      // console.log(isRadioSelected);
 
      const sumStates = () => {
        const weight = weights.find(weight => weight.id === answer);
        // console.log(weight.value);
        props.setChoiceScore(weight.value);
      };
      sumStates(answer);

    }

    return (
      <div className="ms-2 .h7 pt-3 b-3 flex-1">
          <Form.Check onClick={() => onAnswerSelected('always')}
            type='radio'
            id='checkedAlways'
            label='Always'
            name='q1'
            value='always'
            checked={props.selectedBtn === 'always'}
            onChange={handleRadioClick}
          />
          <Form.Check onClick={() => onAnswerSelected('usually')}
            type='radio'
            id='checkedUsually'
            label='Usually'
            name='q1'
            value='usually'
            checked={props.selectedBtn === 'usually'}
            onChange={handleRadioClick}
          />
          <Form.Check onClick={() => onAnswerSelected('sometimes')}
            type='radio'
            id='checkedFifty'
            label='Sometimes - 50/50'
            name='q1'
            value='sometimes'
            checked={props.selectedBtn === 'sometimes'}
            onChange={handleRadioClick}
          />
          <Form.Check onClick={() => onAnswerSelected('rarely')}
            type='radio'
            id='checkedRarely'
            label='Rarely'
            name='q1'
            value='rarely'
            checked={props.selectedBtn === 'rarely'}
            onChange={handleRadioClick}
          />
          <Form.Check onClick={() => onAnswerSelected('never')}
            type='radio'
            id='checkedNever'
            label='Never'
            name='q1'
            value='never'
            checked={props.selectedBtn === 'never'}
            onChange={handleRadioClick}
          />
        </div>
    );
  };

  var harness = 10;
  var invest = 10;
  var quiet = 10;
  var trust = 10;
  var honor = 10;
  var own = 10;
  var connect = 10;
  var be = 10;

function QuizPagination({ answer, showReport, setShowReport, eventNotification, setInvest, setQuiet, setTrust, setHonor, setHarness, setOwn,
    setConnect, setBe, setReportDate, className }) {

  const itemsPerPage = 1;
  const [currentPage, setCurrentPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(0);
  const [isSelected, setSelected] = useState(false)
  const [progress, setProgress] = useState(0);
  const [choiceScore, setChoiceScore] = useState(0);
  const [selectedBtn, setSelectedBtn] = useState("");
  // const [eventData, setEventData] = useState[
  //   {name: "Shenkson Apps - DSP",
  //   message: 'Assessment progress notification.',
  //   }]

  const totalPages = isDev? 15 : Math.ceil(questions.length / itemsPerPage);
  // const totalPages = 15;
  const indexOfLastQuestion = currentPage * itemsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - itemsPerPage;
  const currentQuestions = questions.slice(indexOfFirstQuestion, indexOfLastQuestion);

  
  // console.log(isSelected);
  // // console.log(choiceScore);
  // console.log(currentPage);
  // console.log(totalPages);

  const UseHandleNext = (event) => {
      event.preventDefault();
      setCurrentPage(currentPage + 1);
      setProgress(Math.ceil(currentPage/(totalPages-1)*100));
      setSelected(false);
      setSelectedBtn("");

      var msg0 = "User just started assessment survey";
      var msg25 = "User completed 25% of assessment survey";
      var msg50 = "User completed 50% of assessment survey";
      var msg75 = "User completed 75% of assessment survey";
      var msg100 = "User just completed assessment survey";

       // Prepare event data
       var eventData = {
        name: "Shenkson Apps - DSP",
        message: 'Assessment progress notification.',
      };


      switch(currentPage) {
      // switch(0) {
        case 1:
          eventData = {
            message: 'Assessment progress notification.',
            subject: msg0,
          };
          eventNotification(eventData);
          // setReportDate(new Date());
          break;
        case 12:
          eventData = {
            message: 'Assessment progress notification.',
            subject: msg25,
          };
          eventNotification(eventData);
          break;
        case 24:
          eventData = {
            message: 'Assessment progress notification.',
            subject: msg50,
          };
          eventNotification(eventData);
          break;
        case 36:
          eventData = {
            message: 'Assessment progress notification.',
            subject: msg75,
          };
          eventNotification(eventData);
          break;
        case 48:
        eventData = {
          message: 'Assessment progress notification.',
          subject: msg100,
        };
        eventNotification(eventData);
        setReportDate(new Date());
        break;
      }

      if(currentPage==(totalPages-1)){
        setShowReport(n => true);
      };

      // function sendReport() {  
      //   if(currentPage==(totalPages-1)){
      //     HandleGeneratePdf();
      //   };
      // };

      const weight = weights.find(weight => weight.id === answer);
      // console.log(weight.value);

      switch(questions[currentPage-1].state) {
        case "harness":
          harness = harness + choiceScore;
          setHarness(harness);
          // sendReport();
          return;
        case "invest":
          invest = invest + choiceScore;
          setInvest(invest);
          // sendReport();
          return;
        case "quiet":
          quiet = quiet + choiceScore;
          setQuiet(quiet);
          // sendReport();
          return;
        case "trust":
          trust = trust + choiceScore;
          setTrust(trust);
          // sendReport();
          return;
        case "honor":
          honor = honor + choiceScore;
          setHonor(honor);
          // sendReport();
          return;
        case "own":
          own = own + choiceScore;
          setOwn(own);
          // sendReport();
          return;
        case "connect":
          connect = connect + choiceScore;
          setConnect(connect);
          // sendReport();
          return;
        case "be":
          be = be + choiceScore;
          setBe(be);
          // sendReport();
          return;
      }
  };

 
  var progresscolor = '#CCEE33';

  return (
    <>
    {/* Progress Line */}
    {currentPage!=totalPages && 
    <div>
    <Card className="h-100 fs-8">
      <FalconCardHeader
        title="Assessment Progress"
        // endEl={<FalconLink title="Report" className="px-0" />}
      />
      
      <Card.Body>
        <p className="fs-8 text-600">
          Do not refresh or click previous page.
        </p>

        <ProgressBar
          variant="danger"
          now={progress}
          key={1}
          style={{ height: '6px' }}
          className="rounded-pill mb-3"
        />

        <span className="mb-0 fs-9 text-danger"> {progress}% completed</span>
        <span className="fs-11 text-white">  {dspversion}</span>
        {/* <p className="mb-0 fs-11 text-500">Jan 1st to 30th</p> */}
      </Card.Body>
    </Card>
    </div>
    }

  <div>
    {currentPage!=totalPages && 
    <Card className={className}>
      <Card.Body className="fs-5">
        <Flex>
        {/* <FontAwesomeIcon icon="gift" className="fs-9 text-warning" /> */}
            <div className="ms-2 fs-5 flex-1">
              {currentQuestions.map((question, index) => (
                <div key={index}>
                  <p>{question.question}</p>
                  <AssessmentChoices 
                    setSelectedBtn={setSelectedBtn}
                    selectedBtn={selectedBtn}
                    setSelected={setSelected}
                    setChoiceScore={setChoiceScore}
                    questionId={currentPage} 
                    setInvest={setInvest} 
                    setQuiet={setQuiet}
                    setTrust={setTrust}
                    setHonor={setHonor}
                    setHarness={setHarness}
                    setOwn={setOwn}
                    setConnect={setConnect}
                    setBe={setBe}
                    />
                </div>
              ))}
              <div className='pt-5 col-6'>
                <div className='col-6'>
                    <IconButton
                    variant="danger"
                    className="ms-auto px-5"
                    type="submit"
                    onClick={UseHandleNext}
                    icon={false ? 'chevron-left' : 'chevron-right'}
                    iconAlign="right"
                    transform="down-1 shrink-4"
                    disabled={!isSelected}
                  >NEXT</IconButton>
                </div>
              </div>
            </div>
          </Flex>
        </Card.Body>
      </Card>
      }
  </div>







        
    </>
  );
};

// const DSAQuestions = ({ setInvest, setQuiet, setTrust, setHonor, setHarness,setOwn,
//     setConnect, setBe }) => {
//   return (
//     <QuizPagination setConnect={setConnect} />
//   );
// };

export default DSAssessment;
